module.exports = __webpack_public_path__ + "img/jnhb_bd.a530d60.png";